module.exports = {
    "": "",
    "Menu mobile": "",
    "Logout": "",
    "Choose a destination": "",
    "Where You're Staying": "",
    "Loading": "",
    "Customize your experience": "",
    "Home": "",
    "Transfers": "",
    "All Tours": "",
    "Trending & Reviews": "",
    "Specials": "",
    "Wish List": "",
    "Dining": "",
    "Shopping": "",
    "Contact": "",
    "My Account": "",
    "Tours": "",
    "Get to your hotel with style, select or search your hotel to get our best selection of airport-hotel transfer services. Air conditioned comfortable coaches, minivans or private vehicles will be waiting to take you to your destination.": "",
    "Select your hotel": "",
    "Please select your hotel from the list of available options so we can provide an accurate list of transfer options for your location.": "",
    "Select Airport Option": "",
    "Arrival Airport": "",
    "Departure Airport": "",
    "Select Below": "",
    "Note:": "",
    "If the system shows arrival & departure but round trip is not available, it means that they have to be booked separately.": "",
    "TRANSFERS FOUND:": "",
    " Loading...": "",
    "Loading...": "",
    "Type your Hotel Name": "",
    "Need help?": "",
    "About": "",
    "Privacy Policy": "",
    "About us": "",
    "Account": "",
    "Terms and condition": "",
    "Discover": "",
    "Wishlist": "",
    "Settings": "",
    "Tours Reviews": "",
    "Terms & Conditions": "",
    "Special Offers": "",
    "Empty Cart": "",
    "CHECKOUT": "",
    "We make good vacations great": "",
    "PLACE YOUR ORDER": "",
    "Search Tours": "",
    "Search terms": "",
    "Type your search terms": "",
    "Destination": "",
    "Search Transfers": "",
    "Select": "",
    "Search now": "",
    "Hotel Name": "",
    "CHANGE": "",
    "Seleccione": "",
    "NOT CERTAIN": "",
    "ALL AREAS": "",
    "No Hotels found": "",
    "Select Arrival Airport": "",
    "Rates are per": "",
    "in": "",
    "DESCRIPTION": "",
    "ARRIVAL ONLY": "",
    "(NOT AVAILABLE)": "",
    "ROUND TRIP": "",
    "DEPARTURE ONLY": "",
    "NOT AVAILABLE": "",
    "WELCOME": "",
    "TO": "",
    "<span class='orange_t'>TOUR</span><span class='blue_t'> REVIEWS</span>": "",
    "See What's Hot And What Other vacations have to say": "",
    "See Tours": "",
    "Read Reviews": "",
    "\"...the Royal Swim was perfect for us ...<br />we wanted a great experience and we got it... \"": "",
    "BUY 2 Tours AND GET a 3<sup>rd</sup> ONE FREE": "",
    "<span class='orange_t'>GET</span><span class='yellow_t'> THE</span><span class='blue_t'> APP</span>": "",
    "<span class='orange_t'>FREE</span><span class='blue_t'> TOUR</span>": "",
    "See How!": "",
    "Vacation Offers & Features": "",
    "Download Now!": "",
    "\"FREE CALLS to the concierge before & during vacation<br />Transfers, Tours, and more!\"": "",
    "AIRPORT TRANSFERS ~ GET TO YOUR HOTEL IN STYLE!": "",
    "Our <span class='blue_text'>Destinations</span>": "",
    "Discover our Top tours <span>now</span>": "",
    "Know our places and be happy": "",
    "See our best tour places at Totoura": "",
    "Read more": "",
    "Some <span class='blue_text'>good</span> reasons": "",
    "VACATIONER REVIEWS": "",
    "We have the best reasons to travel": "",
    "Products & Prices Guaranteed!": "",
    "FROM": "",
    "From": "",
    "Details": "",
    "Review": "",
    "Add Cart": "",
    "Add to wishlist": "",
    "Top Rated": "",
    "Delete from wishlist": "",
    "Searching": "",
    "Click on tours you like to build a Wish List": "",
    "Tour & ACTIVITES in": "",
    "We will look for specials and enter you to win your favorites": "",
    "Find your Perfect Tour:": "",
    "By Category": "",
    "3rd Tour Free": "",
    "Land": "",
    "Type your search keyword here & press enter key...": "",
    "Water": "",
    "Cultural": "",
    "Nightlife": "",
    "Adventure": "",
    "Family": "",
    "Select All": "",
    "Unselect All": "",
    "founds": "",
    "Valid 3rd Tour Free": "",
    "Searching...": "",
    "Detail": "",
    "No results found...": "",
    "Name": "",
    "Be in Touch": "",
    "Enter Name": "",
    "Contact Us!": "",
    "\"Enter Email\"": "",
    "Email": "",
    "Message": "",
    "Write your message": "",
    "USA / CANADA": "",
    "Submit": "",
    "CANCUN / COZUMEL PUERTO VALLARTA / LOS CABOS": "",
    "Toll Free": "",
    "DOMINICAN REPUBLIC": "",
    "PUNTA CANA": "",
    "For inquiries please email us at": "",
    "or simply fill out the online contact form": "",
    "PUERTO PLATA": "",
    "Enter your name": "",
    "Enter a valid email": "",
    "Enter your Message - More than 20 characters": "",
    "Arrival": "",
    "Departure": "",
    "Round": "",
    "translate test": "",
    "By agreeing to the Conditions of Use of Totoura?s websites and/or mobile applications Customer agrees to the collection, use and disclosure of its personal information as outlined above.   To the extent provided by applicable law, Customer may request access and correction of its personal information held by TOTOURA by contacting it at the email address set out above.": "",
    "Every individual or legal entity (hereafter referred to as the ?Customer?) by the mere fact of accessing, visiting or registering himself/herself in the Web Site, is automatically subject to the present terms and conditions, as well as to its future modifications. The Customer hereby declares and warrants that he/she is over 18 years of age and has the legal capacity and attributions necessary to purchase or hire in his/her own capacity or in behalf of the legal entity that the Customer declares to represent, as well as to order the charges to the credit card which information he/she provides. The parents and tutors are responsible for the purchases or reservations on-line that are made by the children under their responsibility, with or without their prior approval.": ""
}